import { attr, belongsTo } from "@ember-data/model";
import type ModelRegistry from "@ember-data/types/registries/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class PatientChatMessageSentJournalEvent extends JournalEvent {
  static override type = "patient-chat-message-sent-journal-event";

  @attr("string") declare body: string;

  @attr("date") declare readByPatientAt: Date;

  static override validations(intl: IntlService) {
    return {
      body: validatePresence({
        presence: true,
        description: intl.t(
          "validations.patient-chat-message-sent-journal-event.body"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.patient-chat-message-sent-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "patientChatMessageSentJournalEvents"
  })
  declare patient: Patient;

  @belongsTo("journal-event", {
    async: false,
    inverse: null,
    polymorphic: true
  })
  declare triggeringJournalEvent: JournalEvent;

  async processNotifications(): Promise<
    ModelRegistry["notification-processed-journal-event"][]
  > {
    const unprocessedTriggeredJournalEvents =
      this.notificationTriggeredJournalEvents.filter(je => je.isUnprocessed);

    return Promise.all(
      unprocessedTriggeredJournalEvents.map(je =>
        je.processNotification("auto:chat-opened")
      )
    );
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "patient-chat-message-sent-journal-event": PatientChatMessageSentJournalEvent;
  }
}
